// extracted by mini-css-extract-plugin
export default {"nav-box":"Nav_nav-box__O1kIX","nav-menu":"Nav_nav-menu__jjBDL","logo":"Nav_logo__ewRJA","button":"Nav_button__LyhB3"};